import { CALCULATE_SHIPPING_OPTIONS_REQUEST, CALCULATE_SHIPPING_OPTIONS_SUCCESS, CALCULATE_SHIPPING_OPTIONS_ERROR } from '../types';
export const calculateShippingOptionsRequest = () => {
  return {
    type: CALCULATE_SHIPPING_OPTIONS_REQUEST
  };
};
export const calculateShippingOptionsSuccess = shippingOptions => {
  return {
    type: CALCULATE_SHIPPING_OPTIONS_SUCCESS,
    payload: shippingOptions
  };
};
export const calculateShippingOptionsError = error => {
  return {
    type: CALCULATE_SHIPPING_OPTIONS_ERROR,
    error: true,
    payload: error
  };
};
export const calculateShippingOptions = (order, shippingDetails) => {
  return async (dispatch, getState, _ref) => {
    let {
      chord
    } = _ref;
    dispatch(calculateShippingOptionsRequest());
    const authToken = getState().auth.token;
    try {
      const shippingOptions = await chord.oms.calculateShippingOptions(order, authToken, shippingDetails);
      dispatch(calculateShippingOptionsSuccess(shippingOptions));
      return shippingOptions;
    } catch (error) {
      dispatch(calculateShippingOptionsError(error));
      throw error;
    }
  };
};